import { computed, nextTick, onMounted, onUnmounted } from 'vue'

const getViewportSize = () => {
  const root = document.documentElement
  return {
    width: root.clientWidth,
    height: root.clientHeight
  }
}

export const useViewportScale = (uiStore) => {
  const syncViewport = () => {
    const { width, height } = getViewportSize()
    // 阈值与 SCSS 的 max-aspect-ratio: 1472/828 (设计稿比例) 保持一致:
    // 视口偏窄 (<= 1.78) 时 scale 跟宽度走, 偏宽时跟高度走
    const scale = width / height <= 1472 / 828 ? width / 1472 : height / 828

    uiStore.scale = scale
    uiStore.clientSize = {
      width,
      height
    }
  }

  const handleResize = () => {
    nextTick(() => {
      syncViewport()
    })
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize)
    syncViewport()
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })

  return {
    clientHeight: computed(() => uiStore.clientSize.height || 0),
    syncViewport
  }
}
